const $ = require("jquery");

class JointAnimation {
	constructor (id) {
		this.id = id;
	}

	getRoot () {
		return $(`#${this.id}`);
	}

	getJoint0 () {
		return this.getRoot().find('[data-component=joint-animation-joint-0]');
	}

	getJoint1 () {
		return this.getRoot().find('[data-component=joint-animation-joint-1]');
	}

	/* Rotation in degrees */
	rotate (rot0, rot1) {
		this.getJoint0().css("transform", `rotate(${rot0}deg)`);
		this.getJoint1().css("transform", `rotate(${rot1 - rot0}deg)`);
	}
}

module.exports = JointAnimation;
